import React from 'react'

const DashboardPage = () => <div>&nbsp;</div>

export default DashboardPage
